<template>
  <div class="row mx-2 my-3 pricelist-settings">
      <div class="col-md-12">
          <div class="row">
              <div class="col-sm-12 col-md-7">
                  <h3>Security Info</h3>
              </div>
              <div class="col-sm-12 col-md-3 text-right">
              </div>
              <div class="col-sm-12 col-md-2 text-right">
              </div>
          </div>
          <table
              class="table table-responsive table-striped border-bottom mt-2"
          >
              <thead class="thead-light">
                  <tr>
                      <th>User ID</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Last Password Reset</th>
                      <th class="text-center">Force Reset</th>
                      <th class="text-center">2FA Enabled</th>
                      <th class="text-center">Strong Password</th>
                      <th></th>
                  </tr>
              </thead>
              <tbody>
                  <template
                      v-for="(item, key) in users.data"
                      :key="item.id"
                  >
                      <tr>
                        <td>{{ item.number }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.email }}</td>
                        <td><DateFormatter v-if="item.password_history" :date="item.password_history?.last_reset_at"  /></td>
                        <td class="text-center">
                          <i v-if="item.password_history?.force_reset" class="fas fa-check-circle text-success"></i>
                          <i v-else class="fa-solid fa-circle-xmark text-danger"></i>
                        </td>
                        <td class="text-center">
                          <TwoFactorToggle
                            :user-id="item.id"
                            :initial-state="item.two_factor_auth"
                            @update:modelValue="() => handle2FAChange(item.id)"
                            @error="handleError"
                          />
                        </td>
                        <td class="text-center">
                          <i v-if="item.password_history" class="fas fa-check-circle text-success"></i>
                          <i v-else class="fa-solid fa-circle-xmark text-danger"></i>
                        </td>
                        <td class="text-right">
                          <LockUnlockButton
                            class="d-inline-block"
                            :user="item"
                            :current-user="authUser"
                            @success="handleSuccess"
                          />
                          <ForcePasswordResetButton
                            v-if="!item.password_history?.force_reset"
                            class="d-inline-block"
                            :user="item"
                            :current-user="authUser"
                            @success="handleSuccess"
                          />
                        </td>
                      </tr>
                  </template>
              </tbody>
          </table>

          <Bootstrap4Pagination
              :data="users"
              @pagination-change-page="getResults"
              :align="'right'"
              :limit="1"
              :keepLength="true"
          >
              <template #prev-nav>
                  <i class="fa fa-arrow-left"></i> PREVIOUS</template
              >
              <template #next-nav>
                  NEXT <i class="fa fa-arrow-right"></i>
              </template>
          </Bootstrap4Pagination>
      </div>

  </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { Bootstrap4Pagination } from "laravel-vue-pagination";
import Confirmation from "@/components/Confirmation.vue";
import LockUnlockButton from "../../components/LockUnlockButton.vue"
import ForcePasswordResetButton from "../../components/ForcePasswordResetButton.vue"
import DateFormatter from "../DateFormatter.vue";
import TwoFactorToggle from "./TwoFactorToggle.vue";

export default {
  name: "SecurityInfo",
  components: {
    Bootstrap4Pagination,
    Confirmation,
    LockUnlockButton,
    ForcePasswordResetButton,
    DateFormatter,
    TwoFactorToggle
  },
  
  setup() {
    const store = useStore();
    const route = useRoute();

    const authUser = computed(() => store.state.user);
    const users = computed(() => store.getters.getCurrentUsers);

    onMounted(async () => {
      await store.dispatch('fetchUsers', { page: 1 });
    });

    return {
      store,
      route,
      authUser,
      users,
    };
  },
  
  data() {
    return {
      search: '',
      debouncedFunction: null
    };
  },
  
  methods: {
    async getResults(page = 1) {
      try {
        await this.store.dispatch('fetchUsers', {
          page,
          search: this.search
        });
      } catch (err) {
        console.error(err);
      }
    },

    handleSuccess() {
      this.getResults();
    },

    handleToggleSuccess(data) {
      this.store.commit('users/UPDATE_USER', data);
    },

    async handle2FAChange(userId) {
      try {
        await this.store.dispatch('toggle2FA', userId);
      } catch (error) {
        this.handleError(error);
      }
    },

    handleError(error) {
      console.error(error);
      // Add your error handling logic here
    }
  }
};
</script>